import { z } from "zod/v4-mini";

import { CareTeamParticipant, careTeamParticipantSchema } from "@/models/CareTeamParticipantModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type CareTeam = {
  id: string;
  participants: CareTeamParticipant[];
};

export const careTeamSchema: Schema<CareTeam> = z.object({
  id: z.string(),
  participants: cz.forcedArray(careTeamParticipantSchema),
});
